import { REQUEST_GET_IMAGES_API } from '../../helpers/api';
import { paginatedAttachmentsActions } from '../../redux/slicers/admin/paginatedAttachements';
import { createGetListAction } from '../apiGenerator';

export const getAttachmentsPageListApi = createGetListAction({
  endpoint: REQUEST_GET_IMAGES_API,
  actions: paginatedAttachmentsActions,
  setGlobalSidebarFilters: true,
});